<div class="engagement_code_component">
    <div class="code_section displayFlex align-item-center mb-20">
        <div class="empl_dropdown">
            <mis-dropdown 
            [data]="employees" 
            [searchEnabled]="false" 
            [label]="selectedEmp || 'Select Employee'" 
            height="38px" width="200px"
            dropdownListPosition="Left" 
            dropdownListHeight="100px" 
            noDataMessage="No Data"
            (onChange)="onEmployeeSelect($event)"
            >
            </mis-dropdown>
        </div>   
        <div class="engagement_code_container displayFlexSpaceBetween align-item-center">
            <div class="engagement_input_box">
                <app-field-generator
                    [config]="{elementType: 'textbox'}" 
                    [inputControl]="codeControl" 
                    [placeholder]="'Type Engagement Code'"
                    >
                </app-field-generator>
            </div>
            <ng-container [ngSwitch]="verificationStatus">
                <ng-container *ngSwitchCase="'not_verified'">
                    <button
                    class="verify-btn displayFlex align-item-center fs-15"
                    [disabled]="!codeControl.value" 
                    [ngClass]="{'enabled': codeControl.value}"
                    (click)="verifyCode()"
                    >Verify
                    </button>
                </ng-container>
                <ng-container *ngSwitchCase="'verifying'">
                    <div class="displayFlex align-item-center">
                        <mat-spinner [diameter]="24"></mat-spinner>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'verified'">
                    <div class="displayFlex align-item-center">
                        <img src="assets/assign_approve.svg" alt="verified" class="icon24">
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'re_verify'">
                    <img 
                    src="assets/error-msg.svg" 
                    alt="error" 
                    class="icon24" 
                    [matTooltip]="tooltipMessage"
                    >
                    <button
                    class="verify-btn displayFlex align-item-center"
                    (click)="resetVerification()"
                    >
                        <img src="assets/retry.svg" alt="reverify" class="icon24">
                    </button>
                </ng-container>
            </ng-container>
        </div>
    </div>
    <div class="supervisor_section">
        <table border="0" cellspacing="0" cellpadding="0">
            <thead class="table-header">
                <tr>
                <th class="column-heading">Engagement Code</th>
                <th class="column-heading">Reporting Manager/Partner</th>
                </tr>
            </thead>
            <tbody>
                <tr class="row-container">
                    <ng-container *ngIf="engagementDetails; else noTableData">
                        <td>{{engagementDetails?.engagementCode}}</td>
                        <td>
                            <div class="displayFlexColumn supervisor_details">
                                <!-- <div class="displayFlexColumn" *ngFor="let supervisor of engagementDetails.supervisors">
                                    <span>{{supervisor.name}}</span>
                                    <span>{{supervisor.empId}}</span>
                                    <span>{{supervisor.email}}</span>
                                </div> -->
                                <div class="displayFlexColumn"> 
                                    <span class="sup_name">{{engagementDetails?.manager?.name}}</span>
                                    <span>{{engagementDetails?.manager?.id}}</span>
                                    <span>{{engagementDetails?.manager?.email}}</span>
                                </div>
                                <div class="displayFlexColumn"> 
                                    <span class="sup_name">{{engagementDetails?.partner?.name}}</span>
                                    <span>{{engagementDetails?.partner?.id}}</span>
                                    <span>{{engagementDetails?.partner?.email}}</span>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-template #noTableData>
                        <td class="fs-14 no_table_data" colspan="3">Please search an engagement code to view details and select.</td>
                    </ng-template>
                </tr>
            </tbody>
        </table>        
    </div>
</div>